import React from 'react';
import { Table } from 'antd';
import { ManageCookiesButton } from 'components/Page/Footer/Footer.styled';
import { Container, Flex, Li, Link, MarginBox, Paragraph, Section, SectionHeader, Text, Ul } from 'UI';

export const CookiesES = () => {
  return (
    <Container size={'md'} alignText={'justify'}>
      <MarginBox mt={15} />
      <Flex justify={'center'}>
        <Text type={'h5_bold'}>POLÍTICA DE COOKIES</Text>
      </Flex>
      <MarginBox mt={30} />
      <Paragraph>
        Proteger sus datos en Internet es una prioridad para Renault. Nuestro sitio web utiliza tecnologías como las
        cookies para brindarle una experiencia fluida, personalizada y de alta calidad.
      </Paragraph>
      <Paragraph>
        Puede cambiar sus opciones con respecto a las cookies en cualquier momento utilizando nuestra herramienta de
        gestión de cookies:{' '}
        <ManageCookiesButton $color={'brand_alt'}>
          <button id="ot-sdk-btn" className="ot-sdk-show-settings">
            GESTIONAR MIS OPCIONES
          </button>
        </ManageCookiesButton>
        .
      </Paragraph>
      <Section>
        <SectionHeader title={'1. ¿QUIÉNES SOMOS?'} />
        <Paragraph>
          Bienvenido al sitio web{' '}
          <Link to={'https://rpartstore.renault.com'} external newTab>
            https://rpartstore.renault.com,
          </Link>{' '}
          publicado por Renault SAS. Renault SAS es el responsable independiente del tratamiento de los datos
          recopilados por las cookies y otros rastreadores que se leen o colocan en su dispositivo (en
          adelante,&quot;nosotros&quot;, &quot;nos&quot;, &quot;nuestro&quot;).
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'2. ¿QUÉ SON LAS COOKIES?'} />
        <Paragraph>
          Una cookie es un pequeño archivo informático, un rastreador, que se descarga y lee cuando se visita un sitio
          web, se utiliza una aplicación móvil, se lee un correo electrónico o se instala o utiliza un programa,
          independientemente del tipo de terminal utilizado (ordenador, smartphone, lector digital, consola de
          videojuegos conectada a Internet, etc.)
        </Paragraph>
        <Paragraph>
          Cuando se consulta un sitio web, las cookies pueden enviar información al navegador del usuario y permitir al
          navegador que envíe información al sitio web original (por ejemplo, un ID de inicio de sesión o una elección
          de idioma).
        </Paragraph>
        <Paragraph>
          Las cookies no nos permiten identificar al usuario directamente, sino solo recopilar información específica
          sobre su dispositivo, su navegador, sus interacciones con el sitio web o la aplicación que está utilizando y,
          en algunos casos, su situación geográfica.
        </Paragraph>
        <Paragraph>
          Las tecnologías utilizadas pueden enlazar algunos de los dispositivos que haya utilizado el usuario para
          determinar, con suficiente probabilidad, que estos dispositivos le pertenecen.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'3. ¿PARA QUÉ SE UTILIZAN LAS COOKIES EN ESTE SITIO WEB?'} />
        <Paragraph>Este sitio utiliza tipos diferentes de cookies.</Paragraph>
        <SectionHeader title={'Cookies técnicas'} />
        <Paragraph>
          Estas cookies tienen como finalidad permitir o facilitar la comunicación electrónica (detección de errores de
          conexión, identificación de puntos de conexión, seguridad del sitio web, etc.) o prestar los servicios de
          comunicación online que el usuario solicite expresamente (preferencias de visualización de pantalla,
          almacenamiento de información introducida en formularios, carrito de la compra (en su caso), acceso a su
          cuenta de usuario, utilización del chat o chatbot en nuestra página web, etc.).
        </Paragraph>
        <Paragraph>Estas cookies son necesarias para el correcto funcionamiento de nuestro sitio web.</Paragraph>
        <Paragraph>
          El usuario no puede oponerse al uso de estas cookies y no se requiere su consentimiento, ya que los servicios
          de nuestro sitio web dependen de estas cookies.
        </Paragraph>
        <SectionHeader title={'Cookies analíticas'} />
        <Paragraph>
          La finalidad de estas cookies es analizar el tráfico del sitio web, analizar la experiencia del usuario o
          simplemente recopilar información agregada sobre el flujo de visitas al sitio (por ejemplo, selección del
          idioma, página anterior visitada, marca horaria de la visita o selección de cookies).
        </Paragraph>
        <Paragraph>
          Estas cookies pueden tratar datos relacionados con las páginas visitadas, el tiempo empleado en las páginas
          visitadas, el navegador que utiliza el usuario para visitar estas páginas, su uso del chat o chatbot en
          nuestro sitio web, etc.
        </Paragraph>
        <Paragraph>
          Los datos recopilados por estas cookies también se pueden utilizar para crear algoritmos y perfiles con el fin
          de analizar sus posibles intereses y preferencias por nuestros productos y servicios. Podemos combinar estos
          datos con otra información, como la contenida en nuestra base de datos de clientes.
        </Paragraph>
        <Paragraph>
          El uso y almacenamiento de estas cookies generalmente están sujetos al consentimiento del usuario.
        </Paragraph>
        <Paragraph>
          Con determinadas condiciones, estas cookies pueden instalarse o leerse sin el consentimiento del usuario, por
          ejemplo si la finalidad de las cookies es únicamente analizar los contenidos que ha visitado el usuario.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'4. ¿PARA QUÉ SE UTILIZAN LAS COOKIES EN ESTE SITIO WEB?'} />
        <Paragraph>
          La tabla adjunta contiene el listado de todas las cookies almacenadas y/o utilizadas por este sitio web y sus
          principales características. Siempre que sea posible, estas cookies se alojan en servidores ubicados en el
          Espacio Económico Europeo (EEE) o en el Reino Unido. Sin embargo, dado que algunos de nuestros proveedores de
          servicios tienen su domicilio en países fuera del EEE o del Reino Unido, los datos personales del usuario se
          tratarán en estos países, que pueden tener una normativa en materia de datos personales diferente de la de la
          Unión Europea o del Reino Unido. En ese caso, (i) ponemos especial cuidado en que esta transferencia se lleve
          a cabo de acuerdo con el ordenamiento jurídico aplicable y (ii) aplicamos medidas de seguridad que garanticen
          un nivel adecuado de protección de los datos del usuario (en particular mediante el uso de las cláusulas
          contractuales tipo de la Comisión Europea y, en su caso, las cláusulas contractuales tipo aplicables en el
          Reino Unido.
        </Paragraph>
        <Paragraph>
          Nuestro sitio web puede contener cookies de terceros (agencia de comunicación, servicios de análisis, etc.)
          que les permiten, durante la vida de las cookies, recopilar información de navegación relativa a nuestro sitio
          web. El almacenamiento y uso de estas cookies por parte de terceros están sujetos a las políticas de
          privacidad de dichos terceros. Informamos al usuario de la finalidad de las cookies de terceros en nuestro
          sitio web, así como de los medios a su disposición para seleccionar sus preferencias con respecto a estas
          cookies.
        </Paragraph>
        <Table
          pagination={false}
          rowKey={(record) => record.id}
          columns={[
            {
              title: 'Categoría',
              dataIndex: 'guideline',
              key: 'guideline',
              render: (guideline) => (
                <Link to={guideline} external newTab>
                  CREADA POR RENAULT
                </Link>
              ),
            },
            { title: 'Finalidad', dataIndex: 'type', key: 'type' },
            {
              title: 'Propietario de las cookies',
              dataIndex: 'site',
              key: 'site',
            },
            {
              title: 'Duración del almacenamiento',
              dataIndex: 'duration',
              key: 'duration',
            },
          ]}
          dataSource={[
            {
              id: 0,
              site: 'ONE TRUST',
              type: 'TÉCNICA',
              guideline: 'https://www.onetrust.com/fr/cookie-policy/',
              duration: '6 MESES',
            },
            {
              id: 1,
              site: 'RENAULT',
              type: 'TÉCNICA',
              guideline: 'https://www.renault.fr/cookies.html',
              duration: 'SESIÓN',
            },
            {
              id: 2,
              site: 'MATOMO',
              type: 'ANALÍTICA',
              guideline: 'https://matomo.org/privacy-policy/',
              duration: '13 MESES',
            },
            {
              id: 3,
              site: 'DYNATRACE',
              type: 'ANALÍTICA',
              guideline: 'https://www.dynatrace.com/company/trust-center/privacy/',
              duration: 'SESIÓN',
            },
            {
              id: 4,
              site: 'CONTENTSQUARE',
              type: 'ANALÍTICA',
              guideline: 'https://contentsquare.com/fr-fr/privacy-center/cookie-policy/',
              duration: '13 MESES',
            },
            {
              id: 5,
              site: 'GOOGLE',
              type: 'ANALÍTICA',
              guideline: 'https://policies.google.com/technologies/cookies',
              duration: '13 MESES',
            },
            {
              id: 6,
              site: 'YOUTUBE',
              type: 'RED SOCIAL',
              guideline: 'https://www.youtube.com/t/terms',
              duration: '6 MESES',
            },
          ]}
        />
      </Section>
      <Section>
        <SectionHeader title={'5. ¿CÓMO SE OBTIENE SU CONSENTIMIENTO?'} />
        <Paragraph>
          Cuando visita nuestro sitio web por primera vez, se le solicita que acepte, rechace o realice algunas
          selecciones relativas al uso de cookies, para lo que se mostrará un banner informativo específico.
        </Paragraph>
        <Paragraph>
          Puede revocar su consentimiento en cualquier momento o cambiar sus selecciones (por ejemplo, aceptando solo
          ciertos tipos de cookies) con nuestra herramienta especialmente habilitada con ese fin:{' '}
          <ManageCookiesButton $color={'brand_alt'}>
            <button id="ot-sdk-btn" className="ot-sdk-show-settings">
              GESTIONAR MIS OPCIONES
            </button>
          </ManageCookiesButton>
          .
        </Paragraph>
        <Paragraph>
          Tenga en cuenta que, de acuerdo con la normativa vigente, las cookies que son necesarias para el
          funcionamiento del sitio web no están sujetas a su consentimiento y, por lo tanto, no se pueden desactivar en
          nuestra herramienta de gestión de cookies. Puede impedir su uso cambiando la configuración de su navegador
          (siguiendo la sección &quot;cómo rechazar cookies&quot; a continuación), pero la calidad de su experiencia en
          el sitio web puede verse afectada.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'6. ¿CUÁNTO TIEMPO SE CONSERVA SU CONSENTIMIENTO?'} />
        <Paragraph>
          Cuando el usuario acepta o rechaza todas o parte de las cookies de nuestro sitio web, su selección se guarda y
          almacena (y llevaremos un registro de sus preferencias) durante un periodo máximo de 6 meses. Esto significa
          que cuando el usuario consulte nuestro sitio web más adelante, durante este periodo no solicitaremos ninguna
          acción por su parte con respecto a las cookies, ya que tendremos un registro de sus preferencias almacenadas.
        </Paragraph>
        <Paragraph>
          Una vez finalizado este periodo, le pediremos de nuevo que dé su consentimiento o rechace el uso de cookies.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'7. ¿CÓMO PUEDO GESTIONAR LAS COOKIES?'} />
        <SectionHeader title={'¿Cómo ejercer mi derecho de oposición?'} underline />
        <Paragraph>
          Si no desea que se almacenen cookies en su dispositivo o se recupere información de las cookies instaladas, se
          almacenará una cookie de rechazo en su equipo para que podamos tener constancia de que se ha opuesto al uso de
          cookies. Si elimina esta cookie de rechazo, ya no podremos reconocer que ha rechazado el uso y el
          almacenamiento de cookies.
        </Paragraph>
        <Paragraph>
          El usuario tiene varias opciones para gestionar las cookies, incluyendo su bloqueo y/o su eliminación.{' '}
        </Paragraph>
        <SectionHeader title={'Gestor de cookies'} underline />
        <Paragraph>
          Se incluye un gestor de cookies para que el usuario pueda administrar las cookies almacenadas y/o utilizadas
          en este sitio. En cualquier momento, haciendo clic en el siguiente enlace, podrá acceder al sistema de
          configuración y cambiar sus preferencias, dependiendo del tipo de cookie de que se trate.
        </Paragraph>
        <SectionHeader title={'Herramienta de configuración del navegador'} underline />
        <Paragraph>El usuario también puede gestionar las cookies a través de su navegador.</Paragraph>
        <Paragraph>
          La mayoría de los navegadores están configurados por defecto para aceptar cookies, pero, si lo desea, puede
          elegir aceptar todas las cookies, rechazarlas sistemáticamente o elegir qué cookies acepta según su
          procedencia. También puede eliminar periódicamente las cookies de su dispositivo desde su navegador.
        </Paragraph>
        <Paragraph>
          Sin embargo, no olvide configurar todos los navegadores en sus distintos dispositivos (tabletas, smartphones,
          ordenadores, etc.).
        </Paragraph>
        <Paragraph>
          Cada navegador tiene una configuración diferente para administrar las cookies y sus opciones. Esta información
          está contenida en el menú de ayuda del navegador, donde se indicará cómo cambiar la configuración de cookies.
          Por ejemplo:
        </Paragraph>
        <Paragraph align={'start'}>
          <Ul>
            <Li>
              para Internet Explorer™:{' '}
              <Link external newTab to={'https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies'}>
                https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies
              </Link>{' '}
              ;
            </Li>
            <Li>
              para Safari™:{' '}
              <Link external newTab to={' https://support.apple.com/fr-fr/safari'}>
                https://support.apple.com/fr-fr/safari
              </Link>{' '}
              ;
            </Li>
            <Li>
              para Chrome™:{' '}
              <Link external newTab to={'https://support.google.com/chrome/answer/95647?hl=en&hlrm=en'}>
                https://support.google.com/chrome/answer/95647?hl=en&hlrm=en
              </Link>{' '}
              ;
            </Li>
            <Li>
              para Firefox™:{' '}
              <Link
                external
                newTab
                to={'https://support.mozilla.org/en-US/kb/clear-cookies-and-website-data-single-domain-android'}
              >
                https://support.mozilla.org/en-US/kb/clear-cookies-and-website-data-single-domain-android
              </Link>{' '}
              ;
            </Li>
            <Li>
              para Opera™:{' '}
              <Link external newTab to={'https://help.opera.com/Windows/10.20/en/cookies.html'}>
                https://help.opera.com/Windows/10.20/en/cookies.html.
              </Link>
            </Li>
          </Ul>
        </Paragraph>
        <SectionHeader title={'Módulos de los editores para la formulación de objeciones'} underline />
        <Paragraph>
          El usuario puede elegir desactivar algunas cookies de terceros directamente desde la página del creador de la
          cookie. Esta es la manera:
        </Paragraph>
        <Paragraph align={'start'}>
          <Ul>
            <Li>
              Para desactivar las cookies de Google Analytics, vaya a la página:{' '}
              <Link external newTab to={'https://tools.google.com/dlpage/gaoptout?hl=fr'}>
                https://tools.google.com/dlpage/gaoptout?hl=fr
              </Link>{' '}
              ;
            </Li>
            <Li>
              Para desactivar las cookies de intelliAd, vaya a la página:{' '}
              <Link external newTab to={'https://login.intelliad.com/optout.php'}>
                https://login.intelliad.com/optout.php
              </Link>{' '}
              ;
            </Li>
            <Li>
              Para desactivar las cookies de Adobe, vaya a la página:{' '}
              <Link external newTab to={'https://www.adobe.com/uk/privacy/opt-out.html'}>
                https://www.adobe.com/uk/privacy/opt-out.html
              </Link>{' '}
              ;
            </Li>
          </Ul>
        </Paragraph>
        <SectionHeader title={'Oposición a las plataformas de marketing'} underline />
        <Paragraph>
          Varias plataformas profesionales de publicidad también permiten al usuario rechazar o aceptar las cookies
          utilizadas por las empresas miembros de estas plataformas. Estos mecanismos centralizados no impiden que se
          muestren anuncios, solo bloquean la instalación de cookies cuya finalidad es adaptar los anuncios a los
          intereses del usuario.
        </Paragraph>
        <Paragraph>
          Por ejemplo, puede ir a{' '}
          <Link to={'https://www.youronlinechoices.com'} external newTab>
            www.youronlinechoices.com
          </Link>{' '}
          para evitar que se instalen cookies en su dispositivo. Este sitio está administrado por los profesionales de
          la publicidad digital de la asociación europea EDAA (European Digital Advertising Alliance) y gestionado en
          Francia por el Interactive Advertising Bureau France.
        </Paragraph>
        <Paragraph>
          Este sitio le permite saber qué empresas están registradas en esta plataforma y cuáles le permiten rechazar o
          aceptar las cookies utilizadas por estas empresas para personalizar los anuncios que pueden mostrarse en su
          dispositivo basándose en la información de su navegador:{' '}
          <Link to={'https://www.youronlinechoices.com/pt/your-ad-choices'} external newTab>
            https://www.youronlinechoices.com/pt/your-ad-choices
          </Link>{' '}
        </Paragraph>
        <Paragraph>
          Esta plataforma europea es compartida por cientos de profesionales de la publicidad en Internet y proporciona
          una interfaz centralizada para que el usuario rechace o acepte las cookies que se utilicen para personalizar
          los anuncios que pueden mostrarse en su dispositivo de acuerdo con la experiencia de navegación de su
          dispositivo.
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'8. ¿CÓMO PUEDE EJERCER SUS OTROS DERECHOS?'} />
        <Paragraph>
          De acuerdo con la legislación aplicable en materia de protección de datos personales, el usuario tiene derecho
          a acceder, rectificar, oponerse, limitar el tratamiento y suprimir sus datos personales. Para ejercer estos
          otros derechos, consulte nuestra información sobre la protección de sus datos personales poniéndose en
          contacto con nosotros en{' '}
          <Link to={'mailto:dpo@renault.com'} external>
            dpo@renault.com
          </Link>
          .
        </Paragraph>
      </Section>
      <Section>
        <SectionHeader title={'9. CAMBIOS'} />
        <Paragraph>
          Podremos realizar cambios en esta política siempre que lo consideremos necesario. Le informaremos y/o
          solicitaremos su consentimiento cuando sea necesario o estemos obligados a ello. Por ello le recomendamos que
          consulte esta Política cada vez que visite nuestro sitio web para conocer la versión más reciente.
        </Paragraph>
      </Section>
      <Flex justify={'flex-end'}>
        <Text type={'text'}>Última actualización: Enero 2024</Text>
      </Flex>
      <MarginBox mt={90} />
    </Container>
  );
};
